<button
  class="btn-icon"
  [matMenuTriggerFor]="menu"
  #toggleButton
  *ngIf="show()"
  (click)="$event.stopPropagation()"
  (touchstart)="$event.stopPropagation()"
>
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #menu="matMenu" xPosition="before" class="menu-v2">
  <ng-template #container></ng-template>
</mat-menu>
